import axios from 'axios'
const { VUE_APP_API_URL, VUE_APP_TEST_ERROR } = process.env

// Lookup booking information from a mongo record - this will include the flag to display pricing
const decodeFriendFamily = async (unid) => {
  const result = { error: false, data: '' }

  try {
    const url = VUE_APP_TEST_ERROR || `${VUE_APP_API_URL}/api/decode-link/${unid}`

    const res = await axios.get(url)

    if (res && res.data) {
      result.data = res.data
    }
    return result
  } catch (err) {
    result.error = true
    return result
  }
}

export { decodeFriendFamily }
